export const getCardImageUrl = (card, preferArtCrop = true) => {
  if (!card) return null;

  if (preferArtCrop && card.image_uris?.art_crop) {
    return card.image_uris.art_crop;
  }

  if (card.image_uris?.normal) {
    return card.image_uris.normal;
  }

  if (card.card_faces?.[0]) {
    const face = card.card_faces[0];
    if (preferArtCrop && face.image_uris?.art_crop) {
      return face.image_uris.art_crop;
    }
    if (face.image_uris?.normal) {
      return face.image_uris.normal;
    }
  }

  return null;
};
